import { useParams, useHistory } from "react-router-dom"
import { useEffect, useState } from "react"

import Notification from "@views/common/Notification"

import { activeAccount } from "@services/MemberService"

const ActiveAccount = () => {
    const { id } = useParams()
    const history = useHistory()

    const headers = {
        "Accept-Language": "vi"
    }

    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)

    useEffect(() => {
        if (id) {
            activeAccount(headers, id)
                .then((res) => {
                    if (res?.status === 200) {
                        setSuccess("Kích hoạt thành công")
                        setTimeout(() => {
                            history.push("/profile")
                        }, 2000)
                    }
                })
                .catch((err) => {
                    setError(err)
                })
                .finally(() => {
                    setError(null)
                    setSuccess(null)
                })
        }
    }, [id])

    return (
        <>
            {error && <Notification data={{ error }} />}
            {success && <Notification data={{ success }} />}
        </>
    )
}
export default ActiveAccount
